import qs from "qs";
import { mlnr } from "@/utils/Platform";

const useGolfSamsungNavigation = () => {
  const url = process.env.VUE_APP_GOLFSAMSUNG_URL;

  const navigate = (url) => {
    window.location.href = url;
  };

  const navigatePrivacyPolicyPage = () => {
    navigate(getPrivacyPolicyPageUrl());
  };

  const navigateLoginPage = () => {
    navigate(getLoginPageUrl());
  };

  const navigateReservationPage = () => {
    navigate(getReservationPageUrl());
  };

  const navigateWithdrawalPage = () => {
    navigate(getWithdrawalPageUrl());
  };

  const navigateMyInfoPage = () => {
    navigate(getMyInfoPageUrl());
  };

  function getOrigin() {
    return url;
  }

  function resolve(path, params) {
    const origin = `${getOrigin()}${path}`;
    if (!params) {
      return origin;
    }

    return `${origin}?${qs.stringify(params)}`;
  }

  function getPrivacyPolicyPageUrl() {
    return resolve("/reve/pc/policy/privacy-policy.do");
  }

  function getLoginPageUrl() {
    return resolve(
      mlnr("/reve/mo/login-external.do", "/reve/pc/login-external.do")
    );
  }

  function getWithdrawalPageUrl() {
    return resolve(
      mlnr("/reve/mo/members/my-info.do", "/reve/pc/members/my-info.do")
    );
  }

  function getReservationPageUrl() {
    return resolve(
      mlnr("/reve/mo/reserve/choice.do", "/reve/pc/reserve/choice.do")
    );
  }

  function getMyInfoPageUrl() {
    return resolve(
      mlnr("/reve/mo/members/my-info.do", "/reve/pc/members/my-info.do")
    );
  }

  function getMyGiftCardPageUrl() {
    return resolve(mlnr("/reve/mo/giftcard/selectMyGiftCard.do", ""));
  }

  return {
    getOrigin,
    navigatePrivacyPolicyPage,
    getPrivacyPolicyPageUrl,
    getLoginPageUrl,
    getReservationPageUrl,
    getWithdrawalPageUrl,
    getMyInfoPageUrl,
    getMyGiftCardPageUrl,
    navigateLoginPage,
    navigateReservationPage,
    navigateWithdrawalPage,
    navigateMyInfoPage,
  };
};

export default useGolfSamsungNavigation;
